exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes backgroundchange-95ead036{0%{background-color:#dcdcdc}to{background-color:#b8b8b8;color:aqua}}.loading-block[data-v-95ead036]{background-color:#dcdcdc;border-radius:4px;height:175px;animation:backgroundchange-95ead036 1s ease-in-out 1s infinite alternate}.faux-text-1[data-v-95ead036]{height:20px;width:35%}.faux-text-2[data-v-95ead036]{height:20px;width:70%}.faux-text-3[data-v-95ead036]{height:20px;width:45%}.faux-text-4[data-v-95ead036]{height:20px;width:150px;position:absolute;right:0;bottom:0}", ""]);

// exports
